<template>
  <div id="not-found" class="not-found">
    <div class="common-header">
      <h1 class="header-title">エラー</h1>
    <!-- /header --></div>
    <div class="content">
      <div class="message-area">
        <p>読み込みエラーが発生しました。</p>
        <p>再読み込みいただくか、復旧までしばらくお待ちください。</p>
      </div>
    <!-- /content --></div>
    <CommonFooter />
  <!-- /wrapper --></div>

</template>

<script>

import CommonFooter from './CommonFooter.vue'


export default {
  name: 'NotFound',
  components: {
    CommonFooter,
  },
  props: {
    msg: String
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>
